enum IconName{
    CREATE_ICON = "CREATE_ICON",
    DELETE_ICON = "DELETE_ICON",
    EDIT_ICON = "EDIT_ICON",
}

export default IconName;